import script from "./PdfPpt.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfPpt.vue?vue&type=script&setup=true&lang=js"

import "./PdfPpt.vue?vue&type=style&index=0&id=30ff6e7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ff6e7d"]])

export default __exports__